// @snippet
/**
 * @class Stats
 */
const statsDebug =
  new URL(window.location.href).searchParams.get('statsDebug') !== null|| false;

// Keeps delegated click listeners from being attached twice to the same base node.
const statsEventListenerBases = new WeakSet();
window.dataLayer = window.dataLayer || [];

class Stats {
  static sendEventGA(category, action, label) {
    if (window.ga && ga.create) {
      ga('send', 'event', category, action, label);
    }
  }

  static sendEventGTag(props = {}) {
    if (window.gtag) {
      const event = props.event || 'click';
      if (props.event) {
        delete props.event;
      }
      gtag('event', event, props);
    }
  }

  static sendEventDataLayerViaShopify(props = {}) {
    // if (Shopify?.analytics) {
      const event = props.event || 'gtag-event-click';
      if (props.event) {
        delete props.event;
      }
      //   Shopify.analytics.publish(event, props);
      Stats.sendEvent(event, props);
    // }
  }

  static sendEvent(event, props) {
    const modelContextData = () => ({
      url: document.location.href,
      page_title: document.title,
      page_location: window.location.href,
    });

    let payload = {
      event: event,
      ...props,
      ...modelContextData(),
    };

    window.dataLayer.push(payload);
  }

  static normalizeGtagData(value) {
    if (typeof value === 'string') {
      return value.split(`'`).join('');
    }

    if (Array.isArray(value)) {
      return value.map((item) => Stats.normalizeGtagData(item));
    }

    if (value && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, item]) => [key, Stats.normalizeGtagData(item)])
      );
    }

    return value;
  }

  static validateGtagData(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
  }

  static parseGtagData(item) {
    const gtagData = item?.dataset?.gtagClick || item?.dataset?.gtagData;

    if (!gtagData) {
      return null;
    }

    let parsedData;

    try {
      parsedData = JSON.parse(gtagData);
    } catch (_error) {
      try {
        // Some templates save JSON-like data with single quotes, so normalize as a fallback.
        parsedData = JSON.parse(gtagData.split(`'`).join(`"`));
      } catch (error) {
        if (statsDebug) {
          console.warn('Stats: invalid gtag data', gtagData, error);
        }
        return null;
      }
    }

    if (!Stats.validateGtagData(parsedData)) {
      if (statsDebug) {
        console.warn('Stats: gtag data must be an object', parsedData);
      }
      return null;
    }

    return Stats.normalizeGtagData(parsedData);
  }

  // Uses event delegation so elements added later by lazy-loaded sections still track clicks.
  static fetchByGtagElements(base = document.querySelector('body')) {
    Stats.listenerOnElements(base);
  }

  static listenerOnElements(base = document.querySelector('body')) {
    if (!base || statsEventListenerBases.has(base)) {
      return;
    }

    statsEventListenerBases.add(base);

    // const base = document.querySelector('body'); // the container for the variable content
    const selectorGtag = '.gld-gtag-event--click';
    const selectorGtagClick = '[data-gtag-click]';
    const selectorGtagData = '[data-gtag-data]';
    const selectorGA = '.gld-ga-event--click';

    const execEvent = (event) => {
      const target = event.target;

      // Find the closest trackable element, even when the user clicks a child node inside it.
      const item = target?.closest?.(
        `${selectorGtag}, ${selectorGtagClick}, ${selectorGtagData}, ${selectorGA}`
      );
      if (item && base.contains(item)) {
        const props = Stats.parseGtagData(item);

        // Only send when the element has a valid gtag click payload.
        if (props) {
          if (statsDebug) {
            console.warn('Stats: valid gtag data', props);
          }
          Stats.sendEventDataLayerViaShopify(props);
        }
      }
    };

    base.addEventListener('click', function (event) {
      execEvent(event);
    });
    // base.addEventListener('mousedown', function (event) {
    //     execEvent(event);
    // });
  }

  static eventsOnLoad() {
    window.addEventListener('load', () => {
      Stats.eventTrafficSource();
    });
  }

  static eventTrafficSource() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const source = urlParams.get('source') || urlParams.get('Source');
    if (source === 'tiktok') {
      Stats.sendEventDataLayerViaShopify({
        event: 'onLoad',
        event_category: 'traffic_source',
        event_action: `visit`,
        event_label: source,
      });
    }
  }
}
export default Stats;
